import { useStore } from '../../../store'
import { ScannerMode } from '../../../store/InitialOptionsStore'
import DefaultExpandableList from './DefaultExpandableList'
import PerishableProductExpandableList from './PerishableProductExpandableList'
import PriceShelfLabelExpandableList from './PriceShelfLabelExpandableList'
import ShoppingReceiptExpandableList from './ShoppingReceiptExpandableList'
import SmartphoneBoxExpandableList from './SmartphoneBoxExpandableList'
import VinCodeExpandableList from './VinCodeExpandableList'

export default function ExpandableListSelector() {
  const store = useStore()
  const scannerMode = store.initialOptionsStore.scannerMode.value
  if (scannerMode !== ScannerMode.LabelScanning) {
    return <DefaultExpandableList />
  }
  const preset = store.labelCaptureSettingsStore?.selectedPreset.value
  switch (preset) {
    case 'perishableProduct':
      return <PerishableProductExpandableList />
    case 'smartphoneBox':
      return <SmartphoneBoxExpandableList />
    case 'vinCode':
      return <VinCodeExpandableList />
    case 'shoppingReceipt':
      return <ShoppingReceiptExpandableList />
    case 'priceShelfLabel':
      return <PriceShelfLabelExpandableList />
    default:
      return <DefaultExpandableList />
  }
}
